import React, { Component } from 'react';
import Axios from 'axios';
import { AutoComplete } from 'primereact/autocomplete';
import { MultiSelect } from 'primereact/multiselect';

// Status: o mapa Google oferecia Comercialização/Esgotado/Futuro (nomenclatura do
// MongoDB). No MySQL, 'Comercialização' corresponde a 'Ativo'.
const STATUS_OPTIONS = [
    { value: 'Ativo', label: 'Ativo (Comercialização)' },
    { value: 'Esgotado', label: 'Esgotado' },
    { value: 'Futuro', label: 'Futuro' },
];

const USER_TYPE_OPTIONS = [
    { value: 'lead', label: 'Lead' },
    { value: 'visitante', label: 'Visitante' },
    { value: 'cliente', label: 'Cliente' },
];

const QUARTOS_OPTIONS = [1, 2, 3, 4].map((n) => ({ value: n, label: `${n}` }));

/**
 * Painel de filtros do Mapa de Georreferenciamento (Mapbox). Componente controlado:
 * o pai detém o estado e recebe as mudanças via onChange(campo, valor).
 *
 * Paridade de campos com GeoReferenciamentoMapa/FormFilters.jsx, migrados para
 * PrimeReact. Diferença de contrato: Incorporadora e Nome do Empreendimento passam
 * a viajar como **ids** — é o que EmpreendimentosMapboxController valida
 * (`incorporadoras.*` e `nome_empreendimento.*` são integer), enquanto o endpoint
 * MongoDB legado recebia nomes.
 */
class FormFiltersGeo extends Component {
    state = {
        cidadesSuggestions: [],
        incorporadorasSuggestions: [],
        empreendimentosSuggestions: [],
    };

    // O AutoComplete não esconde o que já foi escolhido, então as sugestões já vêm
    // sem os itens selecionados.
    semSelecionados = (options, selecionados) => {
        const escolhidos = new Set((selecionados || []).map((item) => item.value));

        return options.filter((option) => !escolhidos.has(option.value));
    };

    searchCidade = async (event) => {
        try {
            const response = await Axios.get(`/cidades/json-options/${encodeURIComponent(event.query)}`);
            this.setState({
                cidadesSuggestions: this.semSelecionados(response.data || [], this.props.filters.cidades),
            });
        } catch (e) {
            console.error('[FormFiltersGeo] erro na busca de cidades:', e);
            this.setState({ cidadesSuggestions: [] });
        }
    };

    searchIncorporadora = async (event) => {
        try {
            const response = await Axios.get(`/autocomplete-incorporator-with-id?search=${encodeURIComponent(event.query)}`);
            const options = (response.data || []).map((incorporator) => ({
                value: incorporator.id,
                label: incorporator.text,
            }));
            this.setState({
                incorporadorasSuggestions: this.semSelecionados(options, this.props.filters.incorporadoras),
            });
        } catch (e) {
            console.error('[FormFiltersGeo] erro na busca de incorporadoras:', e);
            this.setState({ incorporadorasSuggestions: [] });
        }
    };

    // Autocomplete de empreendimentos que devolve o id como value (MySQL), formato
    // exigido pelo filtro `nome_empreendimento` do endpoint Mapbox.
    searchEmpreendimento = async (event) => {
        try {
            const response = await Axios.get(
                `/autocomplete-with-cities-ids-as-values?search=${encodeURIComponent(event.query)}`
            );
            const options = (response.data || []).map((building) => ({
                value: building.id,
                label: building.text,
            }));
            this.setState({
                empreendimentosSuggestions: this.semSelecionados(options, this.props.filters.nome_empreendimento),
            });
        } catch (e) {
            console.error('[FormFiltersGeo] erro na busca de empreendimentos:', e);
            this.setState({ empreendimentosSuggestions: [] });
        }
    };

    render() {
        const { filters, onChange, onCidadesChange, onSubmit, onClear, loading } = this.props;
        const { cidadesSuggestions, incorporadorasSuggestions, empreendimentosSuggestions } = this.state;

        return (
            <div className="geo-mapbox-filtros">
                <div className="form-group">
                    <label>Cidade <span className="geo-obrigatorio">*</span></label>
                    <AutoComplete
                        multiple
                        field="label"
                        minLength={2}
                        placeholder={filters.cidades.length ? '' : 'Digite ao menos 2 caracteres'}
                        value={filters.cidades}
                        suggestions={cidadesSuggestions}
                        completeMethod={this.searchCidade}
                        onChange={(e) => onCidadesChange(e.value || [])}
                        inputStyle={{ width: '100%' }}
                        style={{ width: '100%' }}
                    />
                </div>

                <div className="form-group">
                    <label>Incorporadora</label>
                    <AutoComplete
                        multiple
                        field="label"
                        minLength={2}
                        placeholder={filters.incorporadoras.length ? '' : 'Digite ao menos 2 caracteres'}
                        value={filters.incorporadoras}
                        suggestions={incorporadorasSuggestions}
                        completeMethod={this.searchIncorporadora}
                        onChange={(e) => onChange('incorporadoras', e.value || [])}
                        inputStyle={{ width: '100%' }}
                        style={{ width: '100%' }}
                    />
                </div>

                <div className="form-group">
                    <label>Nome do Empreendimento</label>
                    <AutoComplete
                        multiple
                        field="label"
                        minLength={2}
                        placeholder={filters.nome_empreendimento.length ? '' : 'Digite ao menos 2 caracteres'}
                        value={filters.nome_empreendimento}
                        suggestions={empreendimentosSuggestions}
                        completeMethod={this.searchEmpreendimento}
                        onChange={(e) => onChange('nome_empreendimento', e.value || [])}
                        inputStyle={{ width: '100%' }}
                        style={{ width: '100%' }}
                    />
                </div>

                <div className="form-group">
                    <label>Status</label>
                    <MultiSelect
                        options={STATUS_OPTIONS}
                        optionLabel="label"
                        value={filters.status}
                        onChange={(e) => onChange('status', e.value)}
                        style={{ width: '100%' }}
                        placeholder="Selecione"
                        display="chip"
                        showClear
                        maxSelectedLabels={3}
                        selectedItemsLabel="{0} itens selecionados"
                    />
                </div>

                <div className="form-group">
                    <label>Tipo Usuário</label>
                    <MultiSelect
                        options={USER_TYPE_OPTIONS}
                        optionLabel="label"
                        value={filters.user_type}
                        onChange={(e) => onChange('user_type', e.value)}
                        style={{ width: '100%' }}
                        placeholder="Todos"
                        display="chip"
                        showClear
                        maxSelectedLabels={3}
                        selectedItemsLabel="{0} itens selecionados"
                    />
                </div>

                <div className="form-group">
                    <label>Quartos</label>
                    <MultiSelect
                        options={QUARTOS_OPTIONS}
                        optionLabel="label"
                        value={filters.quartos}
                        onChange={(e) => onChange('quartos', e.value)}
                        style={{ width: '100%' }}
                        placeholder="Selecione"
                        display="chip"
                        showClear
                    />
                </div>

                {/* Mesmo rodapé de ações do mapa principal (components/FormFilters.jsx):
                    card-footer sticky + #container-btn-filtros com dois botões Bootstrap
                    (background-brain / default-gray), rótulos em caixa alta. */}
                <div
                    className="card-footer btn-filtro-mobile"
                    style={{
                        position: 'sticky',
                        bottom: 0,
                        backgroundColor: '#FFF',
                        padding: '5px 10px',
                    }}
                >
                    <div className="row" id="container-btn-filtros">
                        <div className="col-6">
                            <button
                                className="btn btn-block background-brain"
                                onClick={onSubmit}
                                disabled={loading}
                            >
                                {loading ? 'BUSCANDO…' : 'BUSCAR'}
                            </button>
                        </div>
                        <div className="col-6">
                            <button className="btn btn-block btn-default default-gray" onClick={onClear}>
                                LIMPAR
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default FormFiltersGeo;
